import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

import { ClickOutsideModule } from 'ng-click-outside';

import { TakeOverPanelComponent } from './components/TakeOverPanel/take-over-panel.component';
import { CommonFormsModule } from '../Forms/forms.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { ButtonModule } from 'primeng/button';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../Misc/misc.module';
import { ProgressBarModule } from 'primeng/progressbar';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        LocalizationModule,
        ClickOutsideModule,
        CommonBasicModule,
        CommonFormsModule,
        A11yModule,
        ProgressBarModule,
        MiscModule
    ],
    declarations: [
        TakeOverPanelComponent
    ],
    exports: [
        TakeOverPanelComponent
    ]
})
export class TakeOverModule { }
